import {createContext, useContext, useState} from "react";
import {Box} from "@mui/material";

export const Colors = {
    DEFAULT: '#FAFAFF',
    SUSPICIOUS: '#FFFF0033',
    FRAUD: '#FF000026'
}

export interface BackgroundContextValue {
    color: (typeof Colors)[keyof typeof Colors];
    setColor: (color: (typeof Colors)[keyof typeof Colors]) => void;
}

const BackgroundContext = createContext<BackgroundContextValue>({
    color: Colors.DEFAULT,
    setColor: () => {}
});

export function convertStringToColor(status: string): string {
    switch (status) {
        case 'DEFAULT':
            return Colors.DEFAULT;
        case 'SUSPICIOUS':
            return Colors.SUSPICIOUS;
        case 'FRAUD':
            return Colors.FRAUD;
        default:
            return Colors.DEFAULT;
    }
}

export const useBackgroundContext = () => {
    const { color, setColor } = useContext(BackgroundContext);

    const setTrafficColor = (traffic: string) => {
        setColor(convertStringToColor(traffic));
    }
    return [color, setTrafficColor, setColor] as const;
};

export const BackgroundContextProvider = ({ children }: { children: React.ReactNode }) => {
    const [color, setColor] = useState(Colors.DEFAULT);

    return (
        <BackgroundContext.Provider value={{ color, setColor }}>
            {children}
        </BackgroundContext.Provider>
    );
};